import { render, staticRenderFns } from "./bind-positioning-devices-fittings-modal.vue?vue&type=template&id=2fc2a602&"
import script from "./bind-positioning-devices-fittings-modal.vue?vue&type=script&lang=js&"
export * from "./bind-positioning-devices-fittings-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports